import React from 'react';
import { Link } from 'react-router-dom';

function TermsPage() {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 20px', color: 'var(--text)' }}>
      <Link to="/" style={{ color: 'var(--primary)', fontSize: '0.9rem', textDecoration: 'none' }}>
        ← 돌아가기
      </Link>

      <h1 style={{ fontSize: '1.6rem', marginTop: 16, marginBottom: 8 }}>서비스 이용약관</h1>
      <p style={{ color: '#8B8B9E', fontSize: '0.85rem', marginBottom: 32 }}>시행일: 2026년 5월 20일</p>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제1조 (목적)</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          본 약관은 SAGUO(이하 "회사")가 제공하는 keunson 서비스(이하 "서비스")의 이용 조건 및 절차, 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제2조 (서비스의 내용)</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          서비스는 인터넷 방송 스트리머를 위한 시청자 후원 분석 도구로서 다음의 기능을 제공합니다.
        </p>
        <ul style={{ lineHeight: 2, color: '#B0B0C0', paddingLeft: 20 }}>
          <li>투네이션, 펀네이션, YouTube 수퍼챗 실시간 후원 수집</li>
          <li>시청자별 누적 후원 금액 랭킹 및 분석</li>
          <li>큰손(고액 후원자) 실시간 알림</li>
          <li>YouTube 라이브 채팅 참여자 모니터링</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제3조 (이용 계약의 성립)</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          이용 계약은 이용자가 본 약관에 동의하고 회원가입을 완료한 시점에 성립됩니다.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제4조 (이용자의 의무)</h2>
        <ul style={{ lineHeight: 2, color: '#B0B0C0', paddingLeft: 20 }}>
          <li>이용자는 회원가입 시 정확한 정보를 제공해야 합니다.</li>
          <li>타인의 계정을 무단으로 사용해서는 안 됩니다.</li>
          <li>서비스를 부정한 목적으로 이용해서는 안 됩니다.</li>
          <li>서비스의 정상적인 운영을 방해하는 행위를 해서는 안 됩니다.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제5조 (회사의 의무)</h2>
        <ul style={{ lineHeight: 2, color: '#B0B0C0', paddingLeft: 20 }}>
          <li>회사는 안정적인 서비스 제공을 위해 최선을 다합니다.</li>
          <li>회사는 이용자의 개인정보를 보호하기 위해 개인정보처리방침을 준수합니다.</li>
          <li>서비스 장애 발생 시 신속한 복구를 위해 노력합니다.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제6조 (서비스의 변경 및 중단)</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          회사는 서비스 개선을 위해 서비스의 전부 또는 일부를 변경하거나 중단할 수 있습니다. 중요한 변경 사항은 서비스 내 공지를 통해 사전에 안내합니다.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제7조 (면책 조항)</h2>
        <ul style={{ lineHeight: 2, color: '#B0B0C0', paddingLeft: 20 }}>
          <li>회사는 천재지변, 서버 장애 등 불가항력으로 인한 서비스 중단에 대해 책임지지 않습니다.</li>
          <li>이용자가 제공한 정보의 정확성에 대한 책임은 이용자에게 있습니다.</li>
          <li>제3자 플랫폼(투네이션, 펀네이션, YouTube)의 API 변경이나 장애로 인한 서비스 제한에 대해 회사는 책임지지 않습니다.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제8조 (회원 탈퇴 및 자격 상실)</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          이용자는 언제든지 회원 탈퇴를 요청할 수 있으며, 회사는 즉시 처리합니다. 본 약관을 위반한 경우 회사는 사전 통보 후 회원 자격을 제한하거나 정지할 수 있습니다.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제9조 (분쟁 해결)</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          서비스 이용과 관련하여 분쟁이 발생한 경우 회사의 소재지를 관할하는 법원을 전속 관할 법원으로 합니다.
        </p>
      </section>

      <section style={{ marginBottom: 40 }}>
        <h2 style={{ fontSize: '1.1rem', marginBottom: 8 }}>제10조 (약관의 변경)</h2>
        <p style={{ lineHeight: 1.8, color: '#B0B0C0' }}>
          회사는 필요한 경우 본 약관을 변경할 수 있으며, 변경 시 서비스 내 공지를 통해 안내합니다. 변경된 약관에 동의하지 않는 이용자는 회원 탈퇴를 요청할 수 있습니다.
        </p>
      </section>
    </div>
  );
}

export default TermsPage;
